import React, { Component } from 'react';
import _ from 'lodash';
import UrlParse from 'url-parse';
import { withAlert } from 'react-alert';
import { compose } from 'redux';
import GeneralHelper from '../../../../helpers/general';
import { Button, Card, Col, Form, Input, Row, Select, Modal } from 'antd';
import OptionHelper from '../../../../helpers/Option';

export class LocationBasicForm extends Component {
	formRef = React.createRef();
	state = {
		name: '',
		slug: '',
		description: '',
		status: '',
		loading: false,
		disableBtn: true,
		showDeleteModal: false
	};

	componentDidMount() {
		const { location } = this.props;
		const { query } = UrlParse(location.search, true);
		const { location: locationDetail } = this.props.pageProps;
		if (query.id && locationDetail) {
 			this.initData();
 		}
	}

	componentDidUpdate(prevProps) {
		const { meta: prevMeta } = prevProps.pageProps;
		const { meta } = this.props.pageProps;
		if (meta && meta !== prevMeta) {
			const alertOptions = {
				type: meta.code === 200 ? 'success' : 'error',
				...(meta.code === 40399 && { timeout: 0 })
			};

			this.props.alert.show(meta.message, alertOptions);
			this.props.resetMeta();
		}
	}

	initData = () => {
		const { location } = this.props;
		const { query } = UrlParse(location.search, true);
		const { location: locationDetail } = this.props.pageProps;
		if (query.id && locationDetail) {
 			const {
 				name,
 				slug,
 				description,
 				status
			} = locationDetail;

			this.setState({
				name,
				slug,
				description,
				status
			});
		}
	};

	onFieldChange = (data) => {
		if(['name', 'description'].includes(data.name)) {
			this.formRef.current.setFieldsValue({[data.name]: GeneralHelper.toNormalCase(data.value)});
		}
		if(data.name === 'slug') {
			this.formRef.current.setFieldsValue({[data.name]: data.value.replaceAll(' ', '-').toLowerCase().replace(/[^a-z0-9-]/g, '')});
		}
		this.setState({ ...this.state, [data.name]: data.value }, () => this.checkValues());
	};

	checkValues = () => {
		const { location: locationDetail } = this.props.pageProps;
		const { location } = this.props;
		const { query } = UrlParse(location.search, true);
		let isValueEqual = false;
		// enable/disable submit button if fields are empty or not empty
		if (query.id) {
			// disable submit button if values are same with prev/default values
			const keys = [
				'name',
				'slug',
				'description',
				'status'
			];
			const newPropArrObj = GeneralHelper.checkIfSameValues(keys, locationDetail);
			const newStateArrObj = GeneralHelper.checkIfSameValues(keys, this.state);
			isValueEqual = _.isEqual(newStateArrObj, newPropArrObj);
		}
		const {
			name,
			slug,
			status
		} = this.state;

		name && slug && status  !== '' && !isValueEqual ? this.setState({ disableBtn: false }) : this.setState({ disableBtn: true });
	};

	onSubmit = async () => {
		this.setState({ loading: true });
		const { disableBtn } = this.state;
		if (!disableBtn) {
			const tempState = { ...this.state };
			// show red error borders of input
			const tempErrorObj = {
				name: tempState.name.match(/Invalid/g) ? true : false,
				slug: tempState.slug.match(/Invalid/g) ? true : false,
				// description: tempState.description.match(/Invalid/g) ? true : false, // Description is not required
				status: tempState.status.match(/Invalid/g) ? true : false
			};
			if (Object.values(tempErrorObj).includes(true)) {
				this.setState({ disableBtn: true });
			} else {
				await this.props.onSubmit(this.state);
				this.setState({ disableBtn: true });
			}
			this.setState({ errors: tempErrorObj });
		}

		this.setState({ loading: false });
	};

	onDelete = async () => {
		this.props.deleteLocationById();
		this.setState({showDeleteModal: false});
	}

	render() {
		const {
			name,
			slug,
			description,
			status,
			loading,
			disableBtn,
			showDeleteModal
		} = this.state;
		const { location: locationDetail } = this.props.pageProps;
		const { location } = this.props;
		const { query } = UrlParse(location.search, true);

		return (
			<Card style={{ margin: '15px 15px 0', border: 0 }}>
				<Form
					ref={this.formRef}
					layout="vertical"
					initialValues={{
						name: !_.isEmpty(locationDetail) ? locationDetail.name : name && name,
						slug: !_.isEmpty(locationDetail) ? locationDetail.slug : slug && slug,
						description: !_.isEmpty(locationDetail) ? locationDetail.description : description && description,
						status: !_.isEmpty(locationDetail) ? locationDetail.status : status && status
					}}
				>
					<Row
						type="flex"
						justify="center"
						align="middle"
					>
						<Col
							xl={7}
							lg={18}
							md={18}
							sm={24}
							xs={24}
						>
							<Form.Item
								label="Location Name"
								name="name"
								rules={[
									{ required: true, message: 'Please enter a name.' }
								]}
							>
								<Input
									onChange={val => {
										const data = {
											name: 'name',
											value: val.target.value
										};
										this.onFieldChange(data);
									}}
									maxLength={80}
								/>
							</Form.Item>
							<Form.Item
								label="Location Identifier"
								name="slug"
								rules={[
									{ required: true, message: 'Please enter a slug.' }
								]}
							>
								<Input
									onChange={val => {
										const data = {
											name: 'slug',
											value: val.target.value
										};
										this.onFieldChange(data);
									}}
									maxLength={80}
								/>
							</Form.Item>
							<Form.Item
								label="Location Description"
								name="description"
							>
								<Input.TextArea
									onChange={val => {
										const data = {
											name: 'description',
											value: val.target.value
										};
										this.onFieldChange(data);
									}}
									rows={4}
								/>
							</Form.Item>
							<Form.Item
								label="Status"
								name="status"
								rules={[
									{ required: true, message: 'Please select a status.' }
								]}
							>
								<Select
									placeholder="Status"
									optionFilterProp="children"
									onChange={val => {
										const data = {
											name: 'status',
											value: val
										};
										this.onFieldChange(data);
									}}
									style={{ width: '100%' }}
								>
									{OptionHelper.locationStatus().map((option, index) => (
										<Select.Option
											key={index}
											value={option.value}
										>{option.text}</Select.Option>
									))}
								</Select>
							</Form.Item>

							<Row
								type="flex"
								justify={query.id ? 'space-between' : 'end'}
							>
								{query.id && (
									<Form.Item>
										<Button
											onClick={() => {
												this.setState({showDeleteModal: true});
											}}
											style={{ background: 'rgb(226, 0, 0)', color: '#fff' }}
										>Delete</Button>
									</Form.Item>
								)}
								<Form.Item>
									<Button
										onClick={this.onSubmit}
										style={{ background: '#003366', color: '#fff' }}
										disabled={ loading || disableBtn }
										loading={ loading }
									>{query.id ? 'Save' : 'Create'}</Button>
								</Form.Item>
							</Row>
						</Col>
					</Row>
				</Form>
				{
					showDeleteModal && (
						<Modal
							title={`Delete Location: ${GeneralHelper.truncateString(name, 40)}`}
							centered
							visible={showDeleteModal}
							onOk={() => this.onDelete()}
							onCancel={() => this.setState({ showDeleteModal: false })}
						>
							Are you sure you want to delete?
						</Modal>
					)
				}
			</Card>
		);
	}
}

export default compose(
	withAlert()
)(LocationBasicForm);
